/**
 * Repaint one appointment in a cached board, without waiting for the server.
 *
 * The board's cache is nested — days, then doctors, then their schedule — and the status
 * the card reads lives on the `consultation` the query builds for each meeting. Walking it
 * here rather than inside the mutation keeps the shape in one place, and makes it testable
 * without a QueryClient.
 *
 * Anything that does not match is returned by reference, so React only re-renders the
 * column that actually changed.
 */
export const applyStatusToCachedBoard = (board, appointmentId, status) => {
  if (!board?.data?.length) return board;

  const matches = (item) =>
    String(item?.consultation?.id) === String(appointmentId);

  let changed = false;

  const days = board.data.map((day) => {
    if (!day?.doctors?.length) return day;

    let dayChanged = false;

    const doctors = day.doctors.map((doctor) => {
      if (!doctor?.schedule?.some(matches)) return doctor;

      dayChanged = true;
      changed = true;

      return {
        ...doctor,
        schedule: doctor.schedule.map((item) =>
          matches(item)
            ? {
                ...item,
                consultation: {
                  ...item.consultation,
                  appointmentStatus: status,
                },
              }
            : item
        ),
      };
    });

    return dayChanged ? { ...day, doctors } : day;
  });

  return changed ? { ...board, data: days } : board;
};
